(function()
{
    'use strict';

    /**
     * Service Based on the https://stackoverflow.com/a/26591042 example
     * @desc directive used to handle file change through angular js
     * @example <input type="file" qe-file-change="yourHandler($event, files)" />
     */
    app
        .directive('qeFileChange', qeFileChange);
	
    qeFileChange.$inject = ['$parse', 'lodashService'];

    function qeFileChange($parse, _)
    {
        var directive =
        {
            link: link,
            require: 'ngModel',
            restrict: 'EA'
        }

        return directive;

        function link($scope, element, attrs, ngModel)
        {
            // Get the function provided in the qe-file-change attribute.
            // Note the attribute has become an angular expression,
            // which is what we are parsing. The provided handler is 
            // wrapped up in an outer function (attrHandler) - we'll 
            // call the provided event handler inside the handler()
            // function below.
            let attrHandler = $parse(attrs['qeFileChange']);

            // This is a wrapper handler which will be attached to the
            // HTML change event.
            let onInputChangeHandler = function (e)
            {
                $scope.$apply(function ()
                {
                    // Execute the provided handler in the directive's scope.
                    // The files variable will be available for consumption
                    // by the event handler.
                    attrHandler($scope,
                    {
                        $event: e,
                        files: e.target.files
                    });
                });
            };

            // This is a wrapper handler which will be attached to the
            // HTML destroy event.
            let onInputDestroyHandler = function (e)
            {
                element.off();
            };

            // This is a wrapper handler which will be attached to the
            // HTML change event.
            let onNgModelRenderHandler = function (e)
            {
                // If the File object is not loaded we reset the input label
                if(!_.isObjectLike(ngModel.$modelValue))
                {
                    element.val('');
                }
            };

            // Attach the handler to the HTML change event 
            element[0].addEventListener('change', onInputChangeHandler, false);
            // Attach the handler to the HTML destroy event 
            element[0].addEventListener('$destroy', onInputDestroyHandler, false);
            // Attach the handler to the $render function 
            ngModel.$render = onNgModelRenderHandler;
        }
    };
})();